import ConferencePage from "./ConferencePage";

export default ConferencePage;
